module.exports = __webpack_public_path__ + "img/arrows-retweet.ed5faa1e.svg";